import type { CityConfig } from "../city-template/types";

export const lexingtonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from Kentucky Office of Vital Statistics in Frankfort. Online, mail, or in-person at 275 E Main St.",
      url: "https://www.chfs.ky.gov/agencies/dph/dehp/vsb/Pages/default.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Kentucky Vital Statistics. Available online and by mail for estate and legal matters.",
      url: "https://www.chfs.ky.gov/agencies/dph/dehp/vsb/Pages/default.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage licenses from the Fayette County Clerk at 162 E Main St in Lexington. Certified copies for passport name changes.",
      url: "https://www.fayettecountyky.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through Fayette Circuit Court Clerk. Required for name change passport corrections.",
      url: "https://kycourts.gov/Courts/Circuit-Court/Pages/Fayette.aspx",
    },
  ],
  city: "Lexington",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "lexington",
  route: "/cities/lexington",
  title: "Emergency Passport Lexington, KY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Lexington, KY — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Fayette County, University of Kentucky, and Bluegrass region travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Lexington, KY",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Lexington and Bluegrass region travelers get their expedited passports as quickly as 24 hours. Serving the University of Kentucky community, horse industry professionals, and Fayette County residents. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Lexington%20Kentucky%20downtown%20cityscape%20with%20the%20Bluegrass%20region%20rolling%20hills%20in%20the%20background%2C%20historic%20thoroughbred%20horse%20farm%20estates%20with%20white%20fences%2C%20modern%20downtown%20buildings%20with%20warm%20Kentucky%20sunset%20light%2C%20clean%20panoramic%20cityscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20vibrant%20bluegrass%20region%20with%20green%20pastures%20and%20downtown%20skyline%2C%20wide%20panoramic%20view&width=1800&height=700&seq=lexington-hero-001&orientation=landscape",
  heroImageAlt: "Lexington Kentucky downtown skyline with Bluegrass region horse farms and rolling hills at golden hour",
  geoPosition: "38.0406;-84.5037",
  geoPlacename: "Lexington, Kentucky",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Approximately 370 miles south of Lexington — about 5.5 hours via I-75",
  },
  nearbyCitiesZips: [
    { name: "Lexington", zips: "40502–40517" },
    { name: "Georgetown", zips: "40324" },
    { name: "Nicholasville", zips: "40356, 40340" },
    { name: "Richmond", zips: "40475, 40476" },
    { name: "Versailles", zips: "40383, 40384" },
    { name: "Frankfort", zips: "40601–40604" },
    { name: "Winchester", zips: "40391, 40392" },
    { name: "Lawrenceburg", zips: "40342" },
    { name: "Paris", zips: "40361, 40362" },
    { name: "Harrodsburg", zips: "40330" },
    { name: "Danville", zips: "40422, 40423" },
    { name: "Berea", zips: "40403, 40404" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Bluegrass region departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Louisville", route: "/louisville" },
    { name: "Fast passport renewal in Bowling Green", route: "/bowling-green" },
    { name: "Emergency passport help in Florence", route: "/florence" },
    { name: "Urgent passport services in Covington", route: "/covington" },
    { name: "Same-day passport help in Georgetown", route: "#" },
    { name: "Passport courier services near Richmond", route: "#" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lexington remotely via secure courier. We do not have a walk-in office in Lexington — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Fayette County travelers.",
  fpcOfficeAddress: "500 W Jefferson St, Louisville, KY 40202",
  fpcOfficeDistance: "Serving all of Fayette County and the Bluegrass region",
  serviceAreaIntro: "From downtown Lexington to the Chevy Chase area, from the University of Kentucky campus to the horse farms of the Bluegrass — Fast Passport Center serves the entire Lexington community and surrounding region. We regularly help travelers from Georgetown, Nicholasville, and Richmond get their passports fast.",
  nearbyCitiesIntro: "We serve all Lexington neighborhoods and nearby Bluegrass region cities including Georgetown, Nicholasville, Richmond, Versailles, Frankfort, Winchester, Lawrenceburg, Paris, Harrodsburg, Danville, and Berea. If you are in Fayette County, central Kentucky, or the Bluegrass region, we have you covered.",
  howItWorksIntro: "Most Lexington travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  servicesIntro: "Whether you're a Keeneland horseman heading to the Dubai sales, a UK student studying abroad in Spain, a bourbon industry professional touring international distilleries, or a Bluegrass family booking your first European vacation — Fast Passport Center handles it with registered courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  mistakesIntro: "Lexington travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Lexington and Bluegrass region travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Lexington? Here are the most common ones we hear from Fayette County travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  dmvWebsite: "https://drive.ky.gov",
  dmvLabel: "Kentucky Transportation Cabinet — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9", unit: "Business Days", label: "Fast Passport Center", tag: "Most Popular", tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5", unit: "Weeks", label: "Fast Passport Center", tag: "Standard Expedited", tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false, smartSaver: true,
    },
    {
      speed: "1–2", unit: "Months", label: "Self-Service (Post Office)", tag: "Slowest", tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false, muted: true,
    },
    {
      speed: "24", unit: "Hours*", label: "Regional Agency Processing", tag: "Emergency Only", tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false, emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Keeneland sale in Dubai next week? UK study abroad orientation in Barcelona in 5 days? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Lexington-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Lexington residents renew fast — no agency visit required for most renewals. Perfect for horse industry professionals, UK faculty, and Bluegrass families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Lexington residents through every step with clear instructions for the nearest acceptance location — from UK's campus to Georgetown.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Keeneland international trip or family vacation stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Bluegrass family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Lexington's horse industry professionals, bourbon executives, and UK researchers traveling while primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a damaged passport is faster than you think. We guide Bluegrass travelers through the replacement so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Lexington KY", description: "Urgent passport processing for Lexington Kentucky travelers with immediate departure needs from LEX or CVG." },
    { name: "Expedited Passport Renewal Lexington KY", description: "Fast passport renewal for Lexington Kentucky residents with a previously-issued passport." },
    { name: "First-Time Passport Lexington KY", description: "New passport application services for Lexington Kentucky residents applying for their first passport." },
    { name: "Child Passport Lexington KY", description: "Minor passport services for Lexington Kentucky families with children under 16." },
    { name: "Name Change Passport Lexington KY", description: "Passport name correction after marriage, divorce, or legal name changes for Lexington residents." },
    { name: "Second Passport Lexington KY", description: "Second passport services for Lexington horse industry professionals, bourbon executives, and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Emily R.",
      location: "Lexington, KY",
      rating: 5,
      text: "I'm a graduate student at UK and needed a passport for a study abroad program to Spain. Fast Passport Center got it done in 4 days. They understood the university timeline and made it stress-free.",
      service: "New Passport",
    },
    {
      name: "David K.",
      location: "Georgetown, KY",
      rating: 5,
      text: "I work in the horse industry and had a last-minute business trip to Dubai. My passport was expired. They renewed it in 48 hours and I made my flight. These guys know how to handle urgent travel.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah M.",
      location: "Nicholasville, KY",
      rating: 5,
      text: "Our family planned a Paris vacation for months and I realized my daughter's passport had expired two weeks before departure. They expedited her child passport in 3 days. Saved our trip to France.",
      service: "Child Passport",
    },
    {
      name: "Thomas B.",
      location: "Richmond, KY",
      rating: 5,
      text: "Had an emergency medical situation requiring travel to Canada within 72 hours. Fast Passport Center processed my emergency passport in 24 hours. I can't thank them enough for their speed and professionalism.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "lexington-1", name: "Lexington Main Post Office", type: "USPS Passport Acceptance Facility",
      address: "760 N Broadway", city: "Lexington", state: "KY", zip: "40508", phone: "(859) 252-1522",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM", distance: "0.3 miles from downtown Lexington",
      website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location Finder",
      notes: "Major facility for Fayette County. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "lexington-2", name: "Fayette County Clerk", type: "County Clerk Passport Acceptance",
      address: "162 E Main St", city: "Lexington", state: "KY", zip: "40507", phone: "(859) 255-8451",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM", distance: "0.1 miles from Lexington Courthouse",
      website: "https://www.fayettecountyky.gov/", websiteLabel: "Fayette County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "lexington-3", name: "Georgetown Post Office", type: "USPS Passport Acceptance Facility",
      address: "115 S Hamilton St", city: "Georgetown", state: "KY", zip: "40324", phone: "(502) 863-1161",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM", distance: "0.2 miles from downtown Georgetown",
      website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location Finder",
      notes: "Convenient for Scott County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "lexington-4", name: "Nicholasville Post Office", type: "USPS Passport Acceptance Facility",
      address: "100 S Main St", city: "Nicholasville", state: "KY", zip: "40356", phone: "(859) 885-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM", distance: "0.3 miles from downtown Nicholasville",
      website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location Finder",
      notes: "Serves Jessamine County. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "lexington-5", name: "Richmond Main Post Office", type: "USPS Passport Acceptance Facility",
      address: "140 N Madison Ave", city: "Richmond", state: "KY", zip: "40475", phone: "(859) 623-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM", distance: "0.2 miles from downtown Richmond",
      website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location Finder",
      notes: "Convenient for Madison County residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "lexington-6", name: "Winchester Post Office", type: "USPS Passport Acceptance Facility",
      address: "120 N Main St", city: "Winchester", state: "KY", zip: "40391", phone: "(859) 744-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM", distance: "0.2 miles from downtown Winchester",
      website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location Finder",
      notes: "Serves Clark County residents. Convenient for Winchester area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    { icon: "ri-error-warning-line", title: "Waiting Too Long to Start", description: "Bluegrass region travelers often assume standard processing will be fine. It takes 8–11 weeks. If you're booking a Keeneland international trip or UK study abroad, start expedited at least 3 weeks before travel." },
    { icon: "ri-error-warning-line", title: "Driving to Chicago Without an Appointment", description: "The Chicago Passport Agency is 370 miles away and requires appointments for life-or-death emergencies only. Many Lexington residents don't realize this before making the 6-hour drive." },
    { icon: "ri-error-warning-line", title: "Wrong Passport Photo", description: "Lexington area photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background. CVS and Walgreens in Lexington usually do fine, but always verify." },
    { icon: "ri-error-warning-line", title: "Incomplete DS-11 Form", description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Fayette County acceptance facilities." },
    { icon: "ri-error-warning-line", title: "Not Accounting for 6-Month Rule", description: "Lexington travelers booking horse industry trips to the Middle East or Asia often don't know their passport must have 6 months remaining beyond the return date." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your Lexington travel date. Complete your secure order in minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Get Your Checklist", description: "We confirm your situation and send a personalized document checklist — exactly what you need." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Overnight from Lexington", description: "Drop at any UPS or FedEx location in Lexington. Documents arrive at our processing center next morning." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through reserved agency slots — no 370-mile drive to Chicago, no public appointment wait." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within your selected timeframe and shipped directly back to you in Lexington." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Lexington before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Lexington for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Lexington?", a: "Fast Passport Center offers fast passport renewal in Lexington in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before a horse industry trip to Dubai or the UK?", a: "Lexington's horse industry — Keeneland, Fasig-Tipton, Godolphin, and dozens of breeding operations — creates year-round international travel to the Middle East, UK, Ireland, and Japan. Many of these trips are booked on short notice. Fast Passport Center's 24–48 hour emergency processing is built for exactly these situations." },
    { q: "Can I get a same-day passport appointment near Lexington?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 6 hour drive from Lexington — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Fayette County residents." },
    { q: "Can I expedite a child passport in Lexington?", a: "Yes. Fast Passport Center expedites child passports in Lexington for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Lexington with DS-64 form guidance and identity verification support." },
    { q: "How do UK students and faculty get expedited passports?", a: "University of Kentucky students and faculty needing passports for study abroad, research conferences, or international programs can use Fast Passport Center's expedited service. Start online, ship documents from any Lexington UPS or FedEx, and most processing takes 2–9 business days." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Lexington Residents",
    intro: "Lexington's unique identity as the Horse Capital of the World, a major university town, and Kentucky's second-largest city — combined with Kentucky having zero regional passport agencies — creates distinct passport timing challenges. Here's what Lexington travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "LEX — Blue Grass Airport",
        subtitle: "Lexington's local gateway — 10 miles from downtown",
        description: "Blue Grass Airport serves Lexington with connections to major hubs (ATL, CLT, DTW, ORD, DFW) for onward international flights. While LEX is a regional airport, many Lexington residents book connecting international itineraries — only to discover passport issues days before their first segment. The convenience of LEX can create a false sense of travel readiness for international connections.",
        tip: "Your passport must be valid before your first flight segment from Lexington, even if that segment is domestic. Waiting until you reach a connecting hub is too late to fix a passport issue.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "CVG — Cincinnati/Northern Kentucky International Airport",
        subtitle: "The nearest full international gateway — 85 miles north on I-75",
        description: "Many Lexington residents with international travel drive to CVG, a Delta hub with direct flights to Paris and seasonal international destinations. The 85-mile drive takes about 90 minutes, but a passport issue discovered at the CVG counter means a 90-minute drive back — without your trip.",
        tip: "CVG international flights often depart in the afternoon, but don't let the drive time lull you into complacency. Always validate your passport at least 4 weeks before a CVG international booking.",
      },
      {
        icon: "ri-trophy-line",
        title: "Horse Industry & Keeneland Global Travel",
        subtitle: "Thoroughbred sales, racing, breeding — an international business",
        description: "Lexington's signature industry operates on a global scale. Keeneland sales attract buyers from Dubai, Japan, the UK, Ireland, and Australia. Horse farm managers travel internationally for breeding seasons, racing meets, and auction viewings — often on 1–2 weeks' notice. The Bluegrass region's horse industry generates more passport urgencies per capita than almost any other industry in the United States.",
        tip: "Horse industry travel is inherently last-minute — a horse comes up for sale, a breeding opportunity opens, and you need to be in Dubai or Newmarket in 10 days. Keep your passport current at all times, or know that our emergency courier service handles these scenarios daily.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "University of Kentucky Study Abroad & Research",
        subtitle: "UK's international programs, faculty research, student exchange",
        description: "UK sends thousands of students and faculty abroad each year through programs spanning engineering, agriculture, equine science, and international studies. From equine research partnerships in Japan to engineering exchanges in Germany — UK's international footprint creates a constant stream of passport demand. Many UK students are first-time applicants during their sophomore year with tight program enrollment windows.",
        tip: "First-time UK applicants must visit an acceptance facility in person. We help students navigate to the nearest acceptance location with the earliest available appointment.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Kentucky's Passport Agency Gap",
      description: "Kentucky has zero regional passport agencies. The nearest options are Chicago (370 miles, 6 hours) and Atlanta (380 miles, 6 hours). This means every urgent Lexington passport situation requires either a full-day drive or our courier service. For virtually all Bluegrass travelers, courier processing is faster, cheaper, and far more practical than driving to either agency city.",
    },
  },
  destinations: {
    title: "Where Lexington Travelers Go — And Why Passports Get Urgent",
    intro: "Lexington's horse industry, university culture, and central Kentucky geography shape where Bluegrass residents travel — and when passport urgencies spike.",
    stats: [
      { stat: "35%", label: "of Lexington expedited requests are horse industry or equine business-related with 1–2 weeks notice" },
      { stat: "1–3 Weeks", label: "average lead time Lexington travelers have from trip booking to international departure" },
      { stat: "Mar–May & Sep–Nov", label: "peak seasons during Keeneland spring and fall meets plus UK study abroad deadlines" },
      { stat: "26 Hours", label: "shortest turnaround we have accommodated for a Lexington horseman departing to Dubai" },
    ],
    destinations: [
      { name: "United Arab Emirates", context: "Dubai World Cup, Godolphin operations, Thoroughbred sales, equine veterinary conferences", urgency: "Horse sales and racing events booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "Newmarket and Tattersalls sales, Cheltenham racing, UK equine research partnerships, heritage travel", urgency: "Bloodstock sales and racing meets booked on short notice", icon: "ri-map-pin-2-line" },
      { name: "Japan", context: "Japan Racing Association partnerships, UK equine science exchanges, Shadai Farm collaborations", urgency: "Equine research travel booked 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "UK engineering and business exchanges, automotive supplier travel, bourbon industry European expansion", urgency: "Industry conference and trade show dates are fixed", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "UK architecture and art programs, bourbon tourism expansion, Bluegrass family European vacations", urgency: "Summer vacation and study abroad bookings peak April–June", icon: "ri-map-pin-2-line" },
      { name: "Canada & Caribbean", context: "Cruise departures, bourbon industry North American travel, Bluegrass family resort vacations", urgency: "Last-minute cruise deals peak January–March", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Kentucky Service Areas",
    crossLinksDesc: "We serve travelers across Kentucky with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Louisville", route: "/louisville" },
      { name: "Bowling Green", route: "/bowling-green" },
      { name: "Florence", route: "/florence" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Lexington", address: "1750 Alysheba Way, Lexington, KY 40509", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Lexington", address: "3317 Tates Creek Rd, Lexington, KY 40502", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Lexington", address: "4051 Lexington Rd, Lexington, KY 40509", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Lexington", address: "1600 Leestown Rd, Lexington, KY 40511", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS Pharmacy — Georgetown", address: "1017 Cherry Blossom Way, Georgetown, KY 40324", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Nicholasville", address: "1120 E Main St, Nicholasville, KY 40356", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Richmond", address: "830 Eastern Bypass, Richmond, KY 40475", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Lexington", address: "235 E Main St, Lexington, KY 40507", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Circuit Court Clerk — Fayette County",
      address: "162 E Main St, Lexington, KY 40507",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Driver's license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Scott County",
      address: "119 N Hamilton St, Georgetown, KY 40324",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Online booking available.",
      featured: false,
    },
    {
      name: "Circuit Court Clerk — Madison County",
      address: "135 W Irvine St, Richmond, KY 40475",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center for Richmond area residents.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Jessamine County",
      address: "101 N Main St, Nicholasville, KY 40356",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Alternative for Jessamine County residents. Walk-ins limited.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LEX", name: "Blue Grass Airport (Lexington)", distance: "10 miles from downtown Lexington",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "The primary airport for Fayette County and the Bluegrass region. Domestic flights with connections to major international hubs.",
      flightUrl: "https://www.bluegrassairport.com/", flightLabel: "Blue Grass Airport", featured: true,
    },
    {
      code: "SDF", name: "Louisville Muhammad Ali International", distance: "80 miles from Lexington",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "Alternative regional airport with flights to major hubs.",
      flightUrl: "https://www.flylouisville.com/", flightLabel: "Louisville Airport", featured: false,
    },
    {
      code: "CVG", name: "Cincinnati/Northern Kentucky International", distance: "85 miles from Lexington",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-75.",
      flightUrl: "https://www.cvgairport.com/", flightLabel: "CVG Airport", featured: false,
    },
  ],
};